import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=41d1eaaa&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"
import style0 from "./PageHeader.scss?vue&type=style&index=0&id=41d1eaaa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d1eaaa",
  null
  
)

export default component.exports